import { Input } from '@/components/ui/input';
import { X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface TaxNumberInputProps {
  value?: string;
  onApply: (taxNumber: string) => void;
}

/** STIR 9 xonali — so'rov faqat raqam to'liq kiritilganda ketadi. */
const TAX_NUMBER_LENGTH = 9;

export const TaxNumberInput = ({ value, onApply }: TaxNumberInputProps) => {
  const { t } = useTranslation();
  const [draft, setDraft] = useState(value || '');

  /** URL tashqaridan o'zgarsa (masalan klaster qatori bosilsa) maydon ham yangilanadi. */
  useEffect(() => setDraft(value || ''), [value]);

  const handleChange = (raw: string) => {
    /** Faqat raqam, 9 tadan oshmaydi. */
    const next = raw.replace(/\D/g, '').slice(0, TAX_NUMBER_LENGTH);
    setDraft(next);

    if (next.length === TAX_NUMBER_LENGTH) {
      onApply(next);
      return;
    }

    /** Tozalansa klasterlar ro'yxatiga qaytadi. */
    if (!next && value) onApply('');
  };

  return (
    <div className="flex h-8 w-[190px] items-center gap-2 rounded-md border border-border bg-white/[0.04] px-3 transition-colors focus-within:border-white/25">
      <Input
        value={draft}
        inputMode="numeric"
        maxLength={TAX_NUMBER_LENGTH}
        onChange={(event) => handleChange(event.target.value)}
        placeholder={t('tax_number_placeholder')}
        className="!px-0 text-white"
      />
      {draft && (
        <button
          type="button"
          onClick={() => handleChange('')}
          className="text-muted-foreground transition-colors hover:text-white"
        >
          <X className="size-4 shrink-0" />
        </button>
      )}
    </div>
  );
};
